import { B400, N0 } from '@atlaskit/theme/colors';
import { DEFAULT_THEME_NAME } from './default-theme';
import { generateTheme } from './theme-generator';
export var atlassianTheme = generateTheme({
  name: DEFAULT_THEME_NAME,
  backgroundColor: N0,
  highlightColor: B400
});
export var defaultTheme = atlassianTheme;